import { Box } from '@mui/material';
import { ColumnDef, DataGrid } from "@arelia-components/ui-atoms/data-grid";
import { useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import { PATHS } from "src/routes";
import { TwilioRegistrationRecord } from "../models";

type Props = {
  twilioRegistrationRecords: TwilioRegistrationRecord[];
};

export function TwilioRegistrationRecordList({ twilioRegistrationRecords: records = [] }: Props) {
  const navigate = useNavigate();

  const handleRowClick = (recordId: string) => {
    navigate(`${PATHS.TWILIO_MONITOR}/${recordId}`);
  };

  const [rows, columns] = useMemo(() => {
    const processedRows = records;

    const columns: ColumnDef[] = [
      {
        field: "dateStarted",
        headerName: "Date",
        type: "text",
        width: "15%"
      },
      {
        field: "fullName",
        headerName: "Full Name",
        type: "text",
        width: "20%"
      },
      {
        field: "status",
        headerName: "Status",
        type: "text",
        width: "15%"
      },
      {
        field: "currentStep",
        headerName: "Current Step",
        type: "text",
        width: "10%"
      },
      {
        field: "errorMessage",
        headerName: "Error Message",
        type: "text",
        width: "40%"
      }
    ];

    return [processedRows, columns];
  }, [records]);

  if (rows.length === 0) {
    return (
      <Box sx={styles.emptyMessage}>
        No Twilio registration data available yet.
      </Box>
    );
  }

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      onRowClick={(rowData) => handleRowClick(rowData.id)}
      sx={styles.dataGrid}
    />
  );
}

const styles = {
  emptyMessage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px"
  },
  dataGrid: {
    '& .MuiDataGrid-row': {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    '& .MuiTableCell-root:last-child': {
      textAlign: 'left'
    }
  }
};
